export const ErrorName = {
  UnhandledRejection: "Critical unhandled rejection error",
  GlobalError: "Critical global error",
  ResizeObserver: "ResizeObserver loop limit exceeded",
  ScriptError: "Script error.",
}
